<div class="flex items-center justify-between py-2 px-common">
	<div class="flex flex-col">
		<div class="pb-1 text-sm font-semibold">{{ title }}</div>
		<div class="text-sm">{{ description }}</div>
	</div>
	<div (click)="onRemoveClick.emit($event)" class="cursor-pointer text-almost-black hover:opacity-70">
		<app-svg-icon [iconName]="'delete-circle.svg'" [iconId]="'delete-circle'"></app-svg-icon>
	</div>
</div>
